var map = {
	"./aws": 54545,
	"./aws.vue": 54545,
	"./azure": 55976,
	"./azure.vue": 55976,
	"./digitalocean": 82377,
	"./digitalocean.vue": 82377,
	"./gcp": 29363,
	"./gcp.vue": 29363,
	"./generic": 96641,
	"./generic.vue": 96641,
	"./harvester": 11901,
	"./harvester.vue": 11901,
	"./linode": 52536,
	"./linode.vue": 52536,
	"./pnap": 77873,
	"./pnap.vue": 77873,
	"./s3": 30199,
	"./s3.vue": 30199,
	"./vmwarevsphere": 74537,
	"./vmwarevsphere.vue": 74537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90210;